'use client';

var initialTreeSelect = {
    selectedParentId: -1,
    selectLevel: 0,
    history: {
        selectedParentId: -1,
        selectLevel: 0,
        bodyScrollPosition: []
    }
};

export { initialTreeSelect };
//# sourceMappingURL=index.js.map
